<!--
 * @Date: 2020-07-14 15:11:00
 * @LastEditTime: 2020-11-23 21:06:18
 * @Description: 侧边栏
--> 
<template>
  <div>
    <!-- <div class="nav-search">
      <el-select
        v-model="value"
        @change="changeApp"
        placeholder="请选择"
        class="select-style"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div> -->

    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>

    
    <div class="bottom-info"  v-if="!isCollapse">
      <div class="userinfo" @click="openModel">
        <svg-icon icon-class="ziliao" />
        <span>个人资料</span>
      </div>
      <div class="logininfo">
        <div style="color:#96a1bd;">已登陆为</div>
        <div>{{username}}</div>
      </div>
      <div class="quit-btn" @click="logout()">登出</div>
    </div>

    <right-panel :isShow="showModel">
        个人资料
    </right-panel>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import RightPanel from "../../../components/RightPanel";

import variables from "@/styles/variables.scss";
// import { appList } from "@/api/app.js";

export default {
  components: { SidebarItem, RightPanel },
  computed: {
    ...mapGetters(["sidebar", "permission_routes"]),
    routes() {
      // return this.$router.options.routes.concat(this.permission_routes);
      return this.$router.options.routes;
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  data() {
    return {
      options: [],
      value: localStorage.getItem("curApp") || "",
      username: localStorage.getItem("user") || "",
      showModel: false
    };
  },
  methods: {
    // ...mapMutations(['open_model']),
    changeApp(val) {
      let cur = this.options.filter((item) => {
        return item.id === val;
      });
      location.reload();
      localStorage.setItem("curApp", cur[0].name);
      localStorage.setItem("curAppId", val);
      localStorage.setItem("curPkg", cur[0].pkg);
    },

    logout() {
      localStorage.clear()
      this.$store.dispatch("user/logout");
      this.$router.push("/login");
    },
    
    openModel(){
       this.showModel = true

    }
  },
  // created() {
  //   appList({ project_id: localStorage.getItem("project_id") }).then((resp) => {
  //     this.options = resp;
  //   });
  // },
};
</script>

<style lang="scss">
.nav-search {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 56px;
  /* border-bottom: 1px solid #ffffff; */
  .select-style {
    .el-input__inner {
      color: #ffffff;
      border: none;
      background: #2d3a5b;
    }
  }
}
.nav-search:after {
  content: "";
  margin: 0 auto;
  background: #e0e0e0;
  width: 180px;
  height: 1px;
  display: block;
}
// .select-style {
//   /deep/.el-input__inner {
//     color: #ffffff ;
//     border: none ;
//     background: #2d3a5b ;
//   }
// }
// .el-input__inner {
//   color: #ffffff !important;
//   border: none !important;
//   background: #2d3a5b !important;
// }
.bottom-info {
  width: 100%;
  height: 150px;
  font-size: 14px;
  padding: 20px 20px 0;
  color: #ffffff;
  .userinfo {
    cursor: pointer;
  }
  .logininfo {
    margin-top: 10px;
    div {
      margin-bottom: 5px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .quit-btn {
    text-align: center;
    margin-top: 10px;
    border-radius: 2px;
    padding: 8px 10px;
    color: #ffffff;
    background: #96a1bd;
    cursor: pointer;
  }
}
</style>